import { jsx as _jsx } from "react/jsx-runtime";
import { createFileRoute, } from '@tanstack/react-router';
import { getLanguages, searchTherapistSearchParamsValidateCoercing, } from '@tymia/main-api';
import { bd, } from '@tymia/shared';
import { prop, } from 'remeda';
import { api, } from '../../../api/Api.js';
import { useConfig, } from '../../../common/config/ConfigProvider.js';
import { configStore, } from '../../../common/config/ConfigStore.js';
import { reportClientError, } from '../../../error/clientErrorReporter.js';
import { SearchTherapist, } from '../../../pages/search/SearchTherapist.js';
import { useTranslation, } from '../../../useTranslation.js';
function validateTherapistSearch(search) {
    // for example, set by ChatGPT or ad campaigns
    delete search.utm_source;
    const [isValid, params] = searchTherapistSearchParamsValidateCoercing(search);
    if (isValid) {
        return params;
    }
    reportClientError({
        type: 'validation-error',
        name: validateTherapistSearch.name,
        details: {
            search,
            isValid,
            params,
        },
    });
    return {};
}
export const Route = createFileRoute('/search/psychotherapists-in-{-$cityslug}')({
    validateSearch: validateTherapistSearch,
    component: SearchTherapistWrapper,
    loaderDeps: prop('search'),
    async loader({ params, deps: search }) {
        const config = configStore.get();
        if (config.state !== 'initialized') {
            throw new Error('Config not initialized');
        }
        return await api.client.therapist.search.request({
            ...search,
            address: params.cityslug,
            locale: config.locale,
        });
    },
});
function SearchTherapistWrapper() {
    const params = Route.useParams();
    const search = Route.useSearch();
    const navigate = Route.useNavigate();
    const response = Route.useLoaderData();
    const config = useConfig();
    const translation = useTranslation();
    if (response.status !== 'ok') {
        return _jsx("div", { children: "Error in loader" });
    }
    const searchResponse = {
        ...response,
        list: response.list.map(t => {
            const distance = bd(t.distance ?? '0');
            return {
                ...t,
                distance: distance.gte(0) ? translation.user.searchTherapist.distance(distance) : undefined,
            };
        }),
        languages: getLanguages(config.locale)
            .filter(({ iso }) => response.languages.includes(iso)),
    };
    return (_jsx(SearchTherapist, { params: params, search: search, searchResponse: searchResponse, navigate: navigate }));
}
//# sourceMappingURL=psychotherapists-in-%7B-$cityslug%7D.js.map